

















import { Component, Vue, Prop } from "vue-property-decorator";
import SelectOption from "../../../common/ui/presenters/select-option";

@Component({})
export default class VStatus extends Vue {
  @Prop() text?: string;
  @Prop() variant?: string;
  @Prop() disabled?: boolean;

  @Prop() options!: SelectOption[];

  input(value: string) {
    this.$emit("input", value);
  }
}
